<template>
<div>
<ContentHeader title="Açık / Kapalı Seçenekleri"  url="QuestionCondition" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">

<ClickEditNumber title="Açık Puanı" :value="items[0].points" :valkey="items[0].id" @dataChanged="dataChanged"  :steps="0.01"  />

<ClickEditNumber title="Kapalı Puanı" :value="items[1].points" :valkey="items[1].id" @dataChanged="dataChanged"  :steps="0.01"  />

</template>

</div>
</template>

<script>
export default {

  name: 'QuestionBooleanOptions',

  data () {
    return {
    	loading:true,
    	items:[],
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
  	async getData()
    {
    	this.loading = await true
        let items = await this.generalApiGetWithoutLoader("questionlists/inputfield/options/"+this.$route.params.id)
        await console.log("QuestionBooleanOptions")
        await console.log(items)
        this.items = await items

        this.loading = await false
    }, 
     dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      //return false
      let formdata = new FormData()
      formdata.append("points",data.value)      
      this.generalSubmission(formdata,"questionlists/inputfield/options/update_points/"+data.key,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log(response);      
      this.items = response.data
      //this.$store.dispatch('questions/setQuestion',this.item)
    },
  }
}
</script>

<style lang="css" scoped>
</style>